<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${addurl}/${inputs.id}` : addurl"
      >
      <div class="row">
          <div class="col-md-12">
            <label for="text_input">
              {{ $t("office_name") }}
            </label>
            <app-input
              id="name"
              type="text"
              :required="true"
              v-model="inputs.office_name"
            />
          </div>
          <div class="col-md-12">
            <label for="text_input">
              {{ $t("address1") }}
            </label>
            <app-input
              id="name"
              type="textarea"
              :required="true"
              v-model="inputs.address1"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <label for="text_input">
              {{ $t("address2") }}
            </label>
            <app-input
              id="address2"
              type="textarea"
              v-model="inputs.address2"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("town") }}
            </label>
            <app-input
              id="name"
              type="text"
              v-model="inputs.town"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("postcode") }}
            </label>
            <app-input
              id="name"
              type="text"
              v-model="inputs.postcode"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("head_office") }}
            </label>
            <app-input
              id="head_office"
              type="select"
              :list="statusLists"
              v-model="inputs.head_office"
              :required="true"
            />
          </div>
        </div>      
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost} from "../../../../../../app/Helpers/AxiosHelper";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    companyId: Number,
  },
  data() {
    return {
      addurl:actions.COMPANY_OFFICE_STORE,
      preloader: false,
      roleLists: [],
      inputs: {
        head_office: 'yes',
        company_id: this.companyId,
      },
      statusLists: [
        { id: "no", value: "No" },
        { id: "yes", value: "Yes" },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  methods: {
    submit() {
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(actions.COMPANY_OFFICE_UPDATE, this.inputs)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
      this.save(this.inputs);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
